import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { games } from "../data/games";

const Footer = ({ t }) => (
  <footer data-testid="site-footer" className="relative pt-24 md:pt-32 pb-10 px-6 md:px-12 border-t border-white/5 overflow-hidden">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24 md:mb-32">
        <div className="md:col-span-2">
          <p className="font-display font-bold text-lg mb-4">
            Conjure<span className="text-magic">flow</span>
          </p>
          <p className="text-sm text-white/50 max-w-xs leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-white/40 mb-5">
            {t.footer.columns.games}
          </p>
          <ul className="space-y-3">
            {games.map((game) => (
              <li key={game.id}>
                <Link
                  to={`/giochi/${game.slug}`}
                  data-testid={`footer-game-link-${game.id}`}
                  className="text-sm text-white/60 hover:text-[#00F0FF] transition-colors duration-300"
                >
                  {game.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <motion.p
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        aria-hidden="true"
        className="font-display font-black uppercase text-center leading-none whitespace-nowrap text-[7.2vw] bg-gradient-to-b from-white/20 to-transparent bg-clip-text text-transparent select-none"
      >
        Conjureflow
      </motion.p>

      <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/30">
          © {new Date().getFullYear()} Conjureflow. {t.footer.rights}
        </p>
        <p className="text-xs text-white/30 font-display tracking-widest uppercase">
          conjureflow.app
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
